import React from 'react';
import './CategoryDropdown.css';

const CategoryDropdown = ({ categories, value, onChange, disabled = false }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || !categories || categories.length === 0}
      className="category-dropdown"
    >
      <option value="">-- Chọn danh mục --</option>
      {categories && categories.map((category) => (
        <option key={category._id} value={category._id}>
          {category.categoryName}
        </option>
      ))}
    </select>
  );
};

export default CategoryDropdown;
